import keyMirror from 'helpers/keymirror';

enum MarketplaceActionTypes {
  // UI Actions
  OPEN_COPY_TRADE_MODAL = 'ALGO_MARKETPLACE/OPEN_COPY_TRADE_MODAL',
  OPEN_ADD_FUNDS_MODAL = 'ALGO_MARKETPLACE/OPEN_ADD_FUNDS_MODAL',
  OPEN_TRAILING_STOP_LOSS_MODAL = 'ALGO_MARKETPLACE/OPEN_TRAILING_STOP_LOSS_MODAL',
  OPEN_EXIT_STRATEGY_MODAL = 'ALGO_MARKETPLACE/OPEN_EXIT_STRATEGY_MODAL',
  OPEN_FORCE_EXIT_CONFIRM_MODAL = 'ALGO_MARKETPLACE/OPEN_FORCE_EXIT_CONFIRM_MODAL',
  CLOSE_COPY_TRADE_MODAL = 'ALGO_MARKETPLACE/CLOSE_COPY_TRADE_MODAL',
  CLOSE_ADD_FUNDS_MODAL = 'ALGO_MARKETPLACE/CLOSE_ADD_FUNDS_MODAL',
  CLOSE_TRAILING_STOP_LOSS_MODAL = 'ALGO_MARKETPLACE/CLOSE_TRAILING_STOP_LOSS_MODAL',
  CLOSE_EXIT_STRATEGY_MODAL = 'ALGO_MARKETPLACE/CLOSE_EXIT_STRATEGY_MODAL',
  CLOSE_FORCE_EXIT_CONFIRM_MODAL = 'ALGO_MARKETPLACE/CLOSE_FORCE_EXIT_CONFIRM_MODAL',
  RESET_ADD_FUNDS_STATUS = 'ALGO_MARKETPLACE/RESET_ADD_FUNDS_STATUS',
  RESET_UPDATE_RISK_VALUE_STATUS = 'ALGO_MARKETPLACE/RESET_UPDATE_RISK_VALUE_STATUS',
  UPDATE_SELECTED_STRATEGY = 'ALGO_MARKETPLACE/UPDATE_SELECTED_STRATEGY',
  RESET_STRATEGY_TRADES = 'ALGO_MARKETPLACE/RESET_STRATEGY_TRADES',
  RESET_STRATEGY_ANALYTICS = 'ALGO_MARKETPLACE/RESET_STRATEGY_ANALYTICS',
  RESET_SUBSCRIPTIONS = 'ALGO_MARKETPLACE/RESET_SUBSCRIPTIONS',

  // API actions
  GET_STRATEGIES = 'ALGO_MARKETPLACE/GET_STRATEGIES',
  GET_STRATEGY_POSITIONS = 'ALGO_MARKETPLACE/STRATEGY_POSITIONS',
  GET_STRATEGY_TRADES = 'ALGO_MARKETPLACE/STRATEGY_TRADES',
  GET_STRATEGY_USER_TRADES = 'ALGO_MARKETPLACE/STRATEGY_USER_TRADES',
  GET_STRATEGY_SUBSCRIPTIONS = 'ALGO_MARKETPLACE/STRATEGY_SUBSCRIPTIONS',
  GET_STRATEGY_ANALYTICS = 'ALGO_MARKETPLACE/STRATEGY_ANALYTICS',
  ADD_FUNDS = 'ALGO_MARKETPLACE/ADD_FUNDS',
  EXIT = 'ALGO_MARKETPLACE/EXIT',
  CANCEL_EXIT = 'ALGO_MARKETPLACE/CANCEL_EXIT',
  FORCE_EXIT = 'ALGO_MARKETPLACE/FORCE_EXIT',
  UPDATE_RISK_VALUE = 'ALGO_MARKETPLACE/UPDATE_RISK_VALUE',
  GET_TIME_RANGE_METRICS_DATA = 'ALGO_MARKETPLACE/GET_TIME_RANGE_METRICS_DATA',
}

const ALGO_ACTION_TYPES = keyMirror({
  // Algo marketplace action types
  [MarketplaceActionTypes.GET_STRATEGIES]: null,
  [MarketplaceActionTypes.GET_STRATEGY_POSITIONS]: null,
  [MarketplaceActionTypes.GET_STRATEGY_TRADES]: null,
  [MarketplaceActionTypes.GET_STRATEGY_SUBSCRIPTIONS]: null,
  [MarketplaceActionTypes.GET_STRATEGY_USER_TRADES]: null,
  [MarketplaceActionTypes.GET_STRATEGY_ANALYTICS]: null,
  [MarketplaceActionTypes.ADD_FUNDS]: null,
  [MarketplaceActionTypes.EXIT]: null,
  [MarketplaceActionTypes.CANCEL_EXIT]: null,
  [MarketplaceActionTypes.FORCE_EXIT]: null,
  [MarketplaceActionTypes.UPDATE_RISK_VALUE]: null,
  [MarketplaceActionTypes.GET_TIME_RANGE_METRICS_DATA]: null,
});

export { ALGO_ACTION_TYPES, MarketplaceActionTypes };
